var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.133,
    height: 128.899,
    viewBox: "0 0 101.133 128.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    transform: "translate(-407.165 -1639.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017",
    transform: "translate(407.165 1639.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M1929.822-538.258a13.049,13.049,0,0,1-13.05,13.049h-75.033a13.05,13.05,0,0,1-13.049-13.049v-75.033a13.05,13.05,0,0,1,13.049-13.049h75.033a13.05,13.05,0,0,1,13.05,13.049Z",
    transform: "translate(-1828.69 626.34)",
    fill: "#0a7da7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3016",
    "data-name": "Group 3016",
    transform: "translate(65.797 8.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3014",
    "data-name": "Group 3014",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    d: "M2099.173-575.258a1.377,1.377,0,0,1-1.355-1.142,15.227,15.227,0,0,0-12.347-12.348,1.378,1.378,0,0,1-1.121-1.595,1.377,1.377,0,0,1,1.595-1.119,17.986,17.986,0,0,1,14.588,14.589,1.377,1.377,0,0,1-1.12,1.594A1.423,1.423,0,0,1,2099.173-575.258Z",
    transform: "translate(-2084.329 591.483)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3015",
    "data-name": "Group 3015",
    transform: "translate(0 6.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M2092.644-556.416a1.379,1.379,0,0,1-1.323-.992,8.908,8.908,0,0,0-6-6,1.378,1.378,0,0,1-.937-1.71,1.378,1.378,0,0,1,1.709-.936,11.693,11.693,0,0,1,7.874,7.875,1.378,1.378,0,0,1-.937,1.709A1.39,1.39,0,0,1,2092.644-556.416Z",
    transform: "translate(-2084.328 566.111)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M1964.631-233.988l15.577,27.914,15.578-27.914Z",
    transform: "translate(-1929.641 334.974)",
    fill: "#0a7da7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    d: "M1982.993-543.024h-24.838a6.556,6.556,0,0,0-6.536,6.535v54.9a6.555,6.555,0,0,0,6.536,6.535h24.838a6.554,6.554,0,0,0,6.536-6.535v-54.9A6.556,6.556,0,0,0,1982.993-543.024Zm-8.66,4.575c0,.361-.421.653-.939.653h-5.639c-.518,0-.938-.292-.938-.653s.42-.654.938-.654h5.638C1973.912-539.1,1974.333-538.809,1974.333-538.449Zm-7.433,52.515a2.421,2.421,0,0,1,2.158-2.617h3.032a2.421,2.421,0,0,1,2.157,2.617,2.421,2.421,0,0,1-2.157,2.617h-3.032A2.422,2.422,0,0,1,1966.9-485.934Zm-10.1,0a2.42,2.42,0,0,1,2.158-2.617h3.033a2.42,2.42,0,0,1,2.156,2.617,2.419,2.419,0,0,1-2.156,2.617h-3.033A2.42,2.42,0,0,1,1956.8-485.934Zm20.21,0a2.42,2.42,0,0,1,2.156-2.617h3.033a2.421,2.421,0,0,1,2.158,2.617,2.421,2.421,0,0,1-2.158,2.617h-3.033A2.421,2.421,0,0,1,1977.005-485.934Zm-10.105-7.349a2.421,2.421,0,0,1,2.158-2.617h3.032a2.42,2.42,0,0,1,2.157,2.617,2.421,2.421,0,0,1-2.158,2.618h-3.032A2.422,2.422,0,0,1,1966.9-493.283Zm-10.1,0a2.421,2.421,0,0,1,2.158-2.617h3.033a2.419,2.419,0,0,1,2.156,2.617,2.42,2.42,0,0,1-2.156,2.618h-3.033A2.421,2.421,0,0,1,1956.8-493.283Zm20.21,0a2.419,2.419,0,0,1,2.156-2.616h3.033a2.419,2.419,0,0,1,2.157,2.616,2.421,2.421,0,0,1-2.157,2.618h-3.033A2.421,2.421,0,0,1,1977.005-493.283Zm-10.105-7.348a2.421,2.421,0,0,1,2.158-2.617h3.032a2.42,2.42,0,0,1,2.158,2.617,2.42,2.42,0,0,1-2.158,2.617h-3.032A2.421,2.421,0,0,1,1966.9-500.631Zm-10.1,0a2.42,2.42,0,0,1,2.158-2.617h3.033a2.421,2.421,0,0,1,2.157,2.617,2.422,2.422,0,0,1-2.157,2.617h-3.033A2.42,2.42,0,0,1,1956.8-500.631Zm20.21,0a2.42,2.42,0,0,1,2.156-2.617h3.033a2.42,2.42,0,0,1,2.157,2.617,2.421,2.421,0,0,1-2.157,2.617h-3.033A2.421,2.421,0,0,1,1977.005-500.631Zm8.072-7.806h-29.006v-25.4h29.006Z",
    transform: "translate(-1512.813 2203.968)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.1d58c978e4ec10d09bb875cc9b952001.svg";
export { ForwardRef as ReactComponent };